import styled from 'styled-components';
import { PulseLoader } from 'react-spinners';
import moment from 'moment';

type Props = {
  hasDates: boolean;
  isLoading: boolean;
  pricePerNight: number;
  selectedDateRange: { start: any; end: any };
  showDateText?: boolean;
  onClickDateText?: () => void;
};

function NightPriceText({
  hasDates,
  isLoading,
  pricePerNight,
  selectedDateRange,
  onClickDateText = () => {},
  showDateText = false
}: Props) {
  const renderPriceText = () => {
    if (!hasDates) {
      return <AddDatesText>Add dates for prices</AddDatesText>;
    }
    if (isLoading) {
      return <PulseLoader />;
    }

    return (
      <PricePerNightTextWrapper>
        ${pricePerNight} <PerNightText>per night</PerNightText>
        {showDateText && (
          <DateText
            onClick={() =>
              onClickDateText()
            }>{`${moment(selectedDateRange.start).format('MM/DD')} - ${moment(selectedDateRange.end).format('MM/DD')}`}</DateText>
        )}
      </PricePerNightTextWrapper>
    );
  };
  return <PriceTextWrapper>{renderPriceText()}</PriceTextWrapper>;
}

export default NightPriceText;

const PriceTextWrapper = styled.div`
  font-size: 24px;
  font-weight: 500;
  justify-content: center;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

const PerNightText = styled.span`
  text-transform: uppercase;
  font-size: 12px;
  color: #7a7a7a;
`;

const PricePerNightTextWrapper = styled.div``;

const AddDatesText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #7a7a7a;
`;

const DateText = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
`;
